import React from 'react';

import Button from 'components/Button';
import Message from 'components/Message';
import TrialReminderTerm from 'components/TrialReminder/TrialReminderTerm';
import Typography from 'components/Typography';

import { useAuth } from 'hooks/useAuth';
import useSubscriptionPlans from 'hooks/useSubscriptionPlans';

import { useUrls } from 'constants/urls';

import flame from './assets/light/Flame.webp';
import unlock from './assets/light/Unlock.webp';
import volume from './assets/light/Volume.webp';

export interface IProps {
  showCTA?: boolean;
  showTitle?: boolean;
  linkTo?: string;
  onInteraction?: () => void;
}

const TrialReminder = ({
  showCTA,
  showTitle = true,
  linkTo,
  onInteraction,
}: IProps) => {
  const { hasPremiumAccess } = useAuth();
  const { maxTrialDuration } = useSubscriptionPlans();
  const { pricingPage } = useUrls();

  if (hasPremiumAccess || maxTrialDuration <= 0) {
    return null;
  }

  return (
    <div className="TrialReminder" data-testid="TrialReminder">
      {showTitle && (
        <Typography variant="h2" centered className="text-center mb-6">
          <Message
            message={{
              id: 'components.TrialReminder.title',
              values: { days: maxTrialDuration },
            }}
          />
        </Typography>
      )}
      <div className="TrialReminder__content mb-6">
        <TrialReminderTerm
          title={
            <Typography variant="h3">
              <Message
                message={{ id: 'components.TrialReminder.term1.title' }}
              />
            </Typography>
          }
          subtitle={
            <Typography variant="small-thick">
              <Message
                message={{
                  id: 'components.TrialReminder.term1.subtitle',
                  values: { days: maxTrialDuration },
                }}
              />
            </Typography>
          }
          icon={{ src: unlock, alt: { id: 'components.TrialReminder.unlock' } }}
        />
        <TrialReminderTerm
          title={
            <Typography variant="h3">
              <Message
                message={{
                  id: 'components.TrialReminder.term2.title',
                  values: { days: maxTrialDuration },
                }}
              />
            </Typography>
          }
          subtitle={
            <Typography variant="small-thick">
              <Message
                message={{ id: 'components.TrialReminder.term2.subtitle' }}
              />
            </Typography>
          }
          icon={{ src: volume, alt: { id: 'components.TrialReminder.volume' } }}
        />
        <TrialReminderTerm
          title={
            <Typography variant="h3">
              <Message
                message={{
                  id: 'components.TrialReminder.term3.title',
                }}
              />
            </Typography>
          }
          subtitle={
            <Typography variant="small-thick">
              <Message
                message={{
                  id: 'components.TrialReminder.term3.subtitle',
                  values: { days: maxTrialDuration },
                }}
              />
            </Typography>
          }
          icon={{ src: flame, alt: { id: 'components.TrialReminder.flame' } }}
          noVerticalLine={true}
        />
      </div>
      {showCTA && (
        <Button
          className="TrialReminder__cta"
          title={{
            id: 'components.TrialReminder.startFreeTrial',
            values: { days: maxTrialDuration },
          }}
          onClick={onInteraction}
          linkTo={linkTo || pricingPage}
        />
      )}
    </div>
  );
};

export default TrialReminder;
